import { Typography } from 'antd';
import React from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import { CellRendererParams } from '../types';
import { MarkedTooltip } from './tooltips';

export const NameRenderer = ({ value, data }: CellRendererParams): string => {
  return renderToStaticMarkup(
    <MarkedTooltip isMarked={data.marked}>
      <Typography>{value}</Typography>
    </MarkedTooltip>,
  );
};
